export const CAPTURE_TEXT = 'text';
export const CAPTURE_NUMBER = 'number';
export const CAPTURE_CHECKBOX = 'checkbox';
export const CAPTURE_MULTISELECT = 'multiselect';
export const CAPTURE_SWITCH = 'switch';
export const CAPTURE_TEXTAREA = 'textarea';
